<template>
    <div>
        <v-img :src='url' :lazy-src='lazy' alt="picture" max-height=500px></v-img>
    </div>
</template>

<script>
    export default {
        name: "ImageComponent",
        props: {
            url: {
                required: true,
                type: String
            },
            lazy: {
                required: true,
                type: String
            }
        },
    }
</script>

<style scoped>
    #blogImage {
        opacity: 0;
        transform: translate3d(0, 50%, 0);
        transition: opacity 0.5s, transform 0.5s;
    }
    .v-lazy-im {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
</style>
